module.exports = __webpack_public_path__ + "svg/payment-way3.svg?eafd1f6a7146e049dcf67d3f1d2ef5b7";